import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faCog, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Checkbox } from "@mui/material";



function SideBarRecursive(sidebaritems) {
  const params = useParams();
  const adminRoleId = localStorage.getItem("adminRole");

  const managerAccessList = useSelector((state) => state.ManagerData.managerAccessList);

  // console.log("managerAccessList",managerAccessList)

  const [keyOpen, setKeyOpen] = useState({});
  const [adminRole, setAdminRole] = useState("");

  useEffect(() => {
    if (adminRoleId) {
      setAdminRole(adminRoleId);
    }
  }, [adminRoleId]);

  const shouldRenderMenuItem = (key, menuItem) => {
    // Check if the menu item itself is accessible
    if (managerAccessList[key]) {
      return true;
    }

    // Check if any of the children should be displayed
    if (menuItem?.children) {
      return Object.keys(menuItem.children).some((childKey) =>
        shouldRenderMenuItem(childKey, menuItem.children[childKey])
      );
    }

    return false;
  };

  const handleClickList = (key) => {
    setKeyOpen((prevKeyOpen) => ({
      ...prevKeyOpen,
      [key]: !prevKeyOpen[key],
    }));
  };


  const renderMenuItems = (items) => {

    const isSingleItem = Object.keys(items).length === 1;

    return Object.keys(items)
      .filter((key) => shouldRenderMenuItem(key, items[key]))
      .map((key) => {
        const menuItem = items[key];
        return (
          <div key={key}>
            <Link to={menuItem?.path}>
              <ListItemButton onClick={() => handleClickList(key)}>
                <ListItemIcon>
                  <FontAwesomeIcon
                    icon={menuItem?.icon}
                    style={{ marginLeft: "20px" }}
                  />
                </ListItemIcon>
                <span className="">{menuItem?.sidebarText}</span>
                {menuItem?.children &&
                  (keyOpen[key] ? <ExpandLess /> : <ExpandMore />)}
              </ListItemButton>
            </Link>
            {menuItem?.children && (
              <Collapse
                in={isSingleItem || keyOpen[key]}
                timeout="auto"
                unmountOnExit
              >
                {renderMenuItems(menuItem.children)}
              </Collapse>
            )}
          </div>
        );
      });
  };
  return <List>{renderMenuItems(sidebaritems)}</List>;
}

export default SideBarRecursive;


